import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../contexts/auth";
import Loader from "../../../components/Loader/Loader";
import "./Invites.css";
import UserService from "../../../services/UserService";
import { InvitationBox } from "./InvitationBox";
import { publish, subscribe, unsubscribe } from "../../../utils/events";
import { NotificationCategory } from "../../../constants/notifications.constants";

const Invites = () => {
	const { user } = useAuth();
	const [showLoader, setShowLoader] = useState(false);
	const [invitations, setInvitations] = useState([]);

	async function getInvitations() {
		setShowLoader(true)
		const response = await UserService.invitations();
		setInvitations(response.data);
		setShowLoader(false)
	}

	function onSseReceived(ssePayload) {
		if (ssePayload.content?.userExternalId !== user.userData.userExternalId) {
			return;
		}
		if (ssePayload.action === 'newNotification' && ssePayload.content?.notification) {
			if (Number(ssePayload.content.notification.categoryId) === NotificationCategory.NewInvitation) {
				getInvitations();
			}
		}
		if (ssePayload.action === 'invitationAction') {
			getInvitations();
		}
	}

	async function onInvitationActionSubmit(invitation) {
		getInvitations()
	}

	useEffect(() => {
		getInvitations();
		subscribe('onSseReceived', onSseReceived);
		return () => unsubscribe('onSseReceived', onSseReceived);
	}, [user])

	return (
		<>
			{showLoader ? (
				<Loader style={{ marginTop: '0px' }} />
			) : (
				<div className="invitations-wrapper">
					{invitations && invitations.length > 0 ? (
						<div>
							{invitations.map((invitation, idx) => (
								<InvitationBox key={idx} invitation={invitation} onSubmit={onInvitationActionSubmit} />
							))}
						</div>
					) : (
						<p className="edit-profile-title-details">
							Nenhum convite no momento.
						</p>
					)}
				</div>
			)}
		</>
	)
}

export default Invites;